/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./squad.vue?vue&type=template&id=bc57ec66&scoped=true"
import script from "./squad.vue?vue&type=script&lang=js"
export * from "./squad.vue?vue&type=script&lang=js"
import style0 from "./squad.vue?vue&type=style&index=0&id=bc57ec66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc57ec66",
  null
  
)

export default component.exports